<template>
  <ol
    v-if="links.length"
    class="CtaListComp"
    :class="olClasses"
  >
    <li
      v-for="(cta, i1) in links"
      :key="`menu-link-${i1 + 1}`"
      :class="liClasses"
    >
      <MultiBtn
        :url="utmHref(cta.url, 'tier-1-cta')"
        :text="cta.btn_text"
        :label="cta.btn_title"
        :icon="cta.btn_icon"
        :theme="theme"
      />
    </li>
  </ol>
</template>

<script>
import MultiBtn from '@/components/buttons/MultiBtn.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CtaList',

  components: {
    MultiBtn
  },

  props: {
    limit: {
      type: Number,
      default: -1
    },
    themeSettings: {
      type: String,
      default: 'menu'
    },
    olClasses: {
      type: String,
      default: '',
    },
    liClasses: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters([ 'myStore' ]),
    // Calls to action
    headerCtaBtnTheme() { return this.myStore(['styles', 'header', 'cta_buttons', 'button_style']) ?? 'button_style_4' },
    menuCtaBtnTheme() { return this.myStore(['styles', 'menu', 'calls_to_action', 'button_style']) ?? 'button_style_1' },
    theme() { return this[`${this.themeSettings}CtaBtnTheme`] || this.menuCtaBtnTheme },
    links() {
      const ctas = this.myStore(['options', 'calls_to_action']) || []
      const validCtas = ctas.filter(({ btn_text, url }) => btn_text && url)
      const limitedCtas = this.limit !== -1 ? validCtas.slice(0, this.limit) : validCtas
      return limitedCtas
    },
  }
}
</script>
